import { store } from "../store";
import { call, takeLatest } from "redux-saga/effects";
import ENV from "../config/env";
import {
  GET_SUBSCRIPTION_PLANS_REQUEST,
  GET_COMPANY_SUBSCRIPTION_REQUEST,
  CREATE_RAZORPAY_ORDER_REQUEST,
} from "./subscriptionManagement.type";
import axiosInstance from "../../api/axiosInstance";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}

function getAuthHeaders() {
  const token = store.getState()?.auth?.accessToken;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

function* getSubscriptionPlansSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}/gateway-service/billing-service/getAll/ActiveDisplaySubscriptions`,
      payload,
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getCompanySubscriptionSaga(action) {
  const { payload, callback } = action;
  const { companyId } = payload;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanySubscriptionMapping?companyId=${companyId}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* createRazorpayOrderSaga(action) {
  const { payload, callback } = action;
  const { subscriptionId, companyId } = payload;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}/gateway-service/billing-service/razorpay/create/Order?subscriptionId=${subscriptionId}&companyId=${companyId}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* subscriptionManagementWatcherSaga() {
  yield takeLatest(GET_SUBSCRIPTION_PLANS_REQUEST, getSubscriptionPlansSaga);
  yield takeLatest(GET_COMPANY_SUBSCRIPTION_REQUEST, getCompanySubscriptionSaga);
  yield takeLatest(CREATE_RAZORPAY_ORDER_REQUEST, createRazorpayOrderSaga);
}
